import { supportedChains, ERC_CONTRACT } from './etheriumConfig';

export function getErcContract(chainId, web3) {
    let abi = ERC_CONTRACT[chainId] && ERC_CONTRACT[chainId].abi  ? ERC_CONTRACT[chainId].abi : null;
    if(abi) {
      return new web3.eth.Contract(
        abi,
        ERC_CONTRACT[chainId].address
      );
    }
    return null;
  }

export function getChainData(chainId) {
    const chainData = supportedChains.filter(
        (chain) => chain.chain_id === chainId
    )[0];

    if (!chainData) {
        // throw new Error("ChainId missing or not supported");
        return {};
    }

    // const API_KEY = process.env.REACT_APP_INFURA_ID;

    // if (
    //   chainData.rpc_url.includes("infura.io") &&
    //   chainData.rpc_url.includes("%API_KEY%") &&
    //   API_KEY
    // ) {
    //   const rpcUrl = chainData.rpc_url.replace("%API_KEY%", API_KEY);

    // }

    return chainData;
}